// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { backgroundVideoStyles } from "@sc/App/Widgets/BackgroundVideo/BackgroundVideo";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

backgroundVideoStyles.wrapper = {
    css: css`
        position: relative;
        margin: auto;
        width: 100%;
        display: flex;
    `,
};

backgroundVideoStyles.videoContainer = {
    css: css`
        position: relative;
        width: 100%;
        height: 100%;

        video {
            width: 100%;
            height: 100%;
            min-height: 480px;
            object-fit: cover;
        }
    `,
};

backgroundVideoStyles.textOverlayWrapper = {
    css: css`
        position: absolute;
        height: 100%;
        top: 0;
        left: 0;
        width: 100%;
        padding: 24px;
        display: flex;
        flex-direction: column;
    `,
};

backgroundVideoStyles.textOverlay = {
    css: css`
        display: flex;
        flex-direction: column;
        justify-content: center;
        flex: 1;

        ${xScreen("lt", "sm")} {
            align-items: center;
            text-align: center;
            justify-content: flex-end;
        }
    `,
};

backgroundVideoStyles.title = {
    size: 20,
    lineHeight: "28px",
    weight: "bold",
    color: "white",
    css: css`
        margin-bottom: 12px;
    `,
};

backgroundVideoStyles.subtitle = {
    size: 16,
    lineHeight: "26px",
    weight: "normal",
    color: "white",
    css: css`
        margin-bottom: 16px;
    `,
};

backgroundVideoStyles.button = {
    css: css`
        max-width: max-content;
    `,
};
